var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhyIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2587_20292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.5624 59.2988L82 50.0004L72.5624 40.7012L74.0831 39.2029C76.714 36.6106 76.714 32.393 74.0837 29.8007C72.8089 28.5454 71.1143 27.8538 69.3119 27.8538C67.5102 27.8538 65.8154 28.5454 64.5414 29.8007L63.0208 31.299L53.5832 22L50.7985 24.7445V29.0819C55.7246 30.2386 59.3993 34.6119 59.3993 39.8147C59.3993 45.018 55.7246 49.3913 50.7985 50.5475V63.9968H42.6286L41 65.6018L53.5834 78L63.0209 68.7008L64.3315 69.9928C66.9624 72.5851 71.2428 72.5851 73.8738 69.9928C76.5047 67.4005 76.5045 63.1829 73.8738 60.5906L72.5624 59.2988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3618 60V46.4046H48.2231C51.9602 46.4046 55 43.3216 55 39.5313C55 35.7415 51.9602 32.6586 48.2231 32.6586H46.3618V19.0634H32.9575V16.8734C32.9573 13.0831 29.9177 10 26.1806 10C22.4441 10 19.4044 13.0831 19.4044 16.8734V19.0634H6V32.6587H7.86192C11.1405 32.6587 13.8821 35.0321 14.5051 38.174C14.7856 38.5696 14.9365 39.0445 14.9365 39.5317C14.9365 40.0189 14.7856 40.4939 14.5051 40.8894C13.8821 44.0308 11.1405 46.4047 7.86192 46.4047H6V60H19.4043V57.8092C19.4043 54.0195 22.4441 50.9366 26.1806 50.9366C29.9177 50.9366 32.9575 54.0195 32.9575 57.8092V60H46.3618Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2587_20292",
    x: -4,
    y: 0,
    width: 96,
    height: 96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2587_20292"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2587_20292",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyIcon1);
export default __webpack_public_path__ + "static/media/why-icon1.e98245fa5e4719c60bb8f6aca0216b04.svg";
export { ForwardRef as ReactComponent };